import PropTypes from 'prop-types'
import React from 'react'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import './InputAddress.scss'

function getAddressComponent(address, addressComponentType) {
  const addressComponent = address.address_components.find((component) =>
    component.types.includes(addressComponentType))
  return addressComponent && addressComponent.long_name
}

export default class InputAddress extends React.Component {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
  }

  state = {
    address: '',
  }

  getAddress = (address) => {
    geocodeByAddress(address)
      .then((results) =>
        //return getLatLng(results[0])
        results[0])
      .then((result) => {
        const { onSuccess } = this.props

        getLatLng(result).then((latLngResult) => {
          if (onSuccess) {
            onSuccess(
              result.formatted_address || '',
              latLngResult.lat || '',
              latLngResult.lng || '',
              getAddressComponent(result, 'administrative_area_level_1') || '',
              getAddressComponent(result, 'country') || '',
            )
          }
        })

        //this.setState({
        //  geocodeResults: this.renderGeocodeSuccess(lat, lng),
        //  loading: false,
        //})
      })
      .catch((error) => {
        console.log('Oh no!', error)
        //this.setState({
        //  geocodeResults: this.renderGeocodeFailure(error),
        //  loading: false,
        //})
      })
  }

  handleChange = (address) => {
    //console.log(address)
    //this.setState({ address })

    //console.log('address', address)

    if (address) {
      this.setState({ address })
    } else {
      this.setState({ address: '' })
      this.props.onSuccess(null)
    }
  }

  handleSelect = (address) => {
    this.setState({ address })
    this.getAddress(address)
    // geocodeByAddress(address)
    //   .then((results) => {
    //     //return getLatLng(results[0])
    //     return results[0]
    //   })
    //   .then((result) => {
    //     const { onSuccess } = this.props

    //     getLatLng(result).then((latLngResult) => {
    //       if (onSuccess) {
    //         onSuccess(
    //           latLngResult.lat || '',
    //           latLngResult.lng || '',
    //           getAddressComponent(result, 'administrative_area_level_1') || '',
    //           getAddressComponent(result, 'country') || '',
    //         )
    //       }
    //     })

    //     //this.setState({
    //     //  geocodeResults: this.renderGeocodeSuccess(lat, lng),
    //     //  loading: false,
    //     //})
    //   })
    //   .catch((error) => {
    //     console.log('Oh no!', error)
    //     //this.setState({
    //     //  geocodeResults: this.renderGeocodeFailure(error),
    //     //  loading: false,
    //     //})
    //})
  }

  render() {
    const { address } = this.state
    const componentClassNames = {
      input: 'uk-input',
    }

    const AutocompleteItem = ({ formattedSuggestion }) => (
      <div className="Demo__suggestion-item">
        <i className="fa fa-map-marker Demo__suggestion-icon" />
        <strong>{formattedSuggestion.mainText}</strong>{' '}
        <small className="text-muted">
          {formattedSuggestion.secondaryText}
        </small>
      </div>
    )

    return (
      <PlacesAutocomplete
        {...this.props}
        classNames={componentClassNames}
        highlightFirstSuggestion
        inputProps={{
          value: address,
          onChange: this.handleChange,
        }}
        renderSuggestion={AutocompleteItem}
        onSelect={this.handleSelect}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/InputAddress/InputAddress.js